export default __webpack_public_path__ + "static/media/nodata-found.92821391.svg";